import { useEffect } from 'react';
import { usePaginationParams } from '@common-fe/common-fe';

const DEFAULT_PER_PAGE = 20;
const FIRST_PAGE = 1;

const useUnappliedFundsOrganizationsFilters = () => {
  const { page, setPage, perPage, setPerPage, searchString, setSearchString, currentSearch } =
    usePaginationParams(DEFAULT_PER_PAGE);

  useEffect(() => {
    setPage(FIRST_PAGE);
  }, [currentSearch, setPage]);

  return { page, setPage, perPage, setPerPage, searchString, setSearchString, currentSearch };
};

export default useUnappliedFundsOrganizationsFilters;
